/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Quota
 */
export interface Quota {
    /**
     * 
     * @type {number}
     * @memberof Quota
     */
    current: number;
    /**
     * 
     * @type {number}
     * @memberof Quota
     */
    soft: number | null;
    /**
     * 
     * @type {number}
     * @memberof Quota
     */
    hard: number | null;
}

export function QuotaFromJSON(json: any): Quota {
    return QuotaFromJSONTyped(json, false);
}

export function QuotaFromJSONTyped(json: any, ignoreDiscriminator: boolean): Quota {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'current': json['current'],
        'soft': json['soft'],
        'hard': json['hard'],
    };
}

export function QuotaToJSON(value?: Quota | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'current': value.current,
        'soft': value.soft,
        'hard': value.hard,
    };
}


